$(document).ready(function(){
    $('.text-slider').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  });


  // document.addEventListener('DOMContentLoaded', () => {
  //   const header = document.querySelector('.site-header');
  
  //   window.addEventListener('scroll', () => {
  //     if (window.scrollY > 50) {
  //       header.classList.add('shrink'); // Apply the "shrink" class when scrolling down
  //     } else {
  //       header.classList.remove('shrink'); // Remove the "shrink" class when at the top
  //     }
  //   });
  // });


  function decreaseQuantity() {
    const quantityInput = document.getElementById("quantity");
    let quantity = parseInt(quantityInput.value, 10);
    if (quantity > 1) {
      quantityInput.value = quantity - 1;
    }
  }
  
  function increaseQuantity() {
    const quantityInput = document.getElementById("quantity");
    let quantity = parseInt(quantityInput.value, 10);
    quantityInput.value = quantity + 1;
  }
  
  function openTab(event, tabId) {
    // Remove "active" class from all buttons
    const buttons = document.querySelectorAll('.prodfooterTabs .tab-btn');
    buttons.forEach(btn => btn.classList.remove('active'));
  
    // Remove "active" class from all tab panels
    const panels = document.querySelectorAll('.prodfooterTabs .tab-panel');
    panels.forEach(panel => panel.classList.remove('active'));
  
    // Add "active" class to the clicked button and corresponding panel
    event.target.classList.add('active');
    document.getElementById(tabId).classList.add('active');
  }
  